export const ADD_ONBOARDING_ITEM = 'ADD_ONBOARDING_ITEM';
export const DELETE_ONBOARDING_ITEM = 'DELETE_ONBOARDING_ITEM';
export const LOAD_ONBOARDING = 'LOAD_ONBOARDING';
export const LOAD_ONBOARDING_SUCCESS = 'LOAD_ONBOARDING_SUCCESS';
